
import VideoCircle from "../../../assets/outline/VideoCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoCircleIcon({ className, dataTestid = "VideoCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
